import React from "react";
import TopBannar from "./TopBannar/TopBannar";
import ClientsAndMarkets from "./ClientsAndMarkets/ClientsAndMarkets";
import Progess from "./Progess/Progess";
import Incorporate from "./Incorporate/Incorporate";
import InvestingFoundation from "./InvestingFoundation/InvestingFoundation";
import GetStarted from "./GetStarted/GetStarted";
import WhyChoose from "./WhyChoose/WhyChoose";
import InstantAccess from "./InstantAccess/InstantAccess";

const Home = () => {
  return (
    <>
      <TopBannar />
      <ClientsAndMarkets />
      <Progess />
      <Incorporate />
      <WhyChoose />
      <InvestingFoundation />
      <GetStarted />
      <InstantAccess />
     
    </>
  );
};

export default Home;
